var React = require('react');

function FacebookWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.0229 20L10 13H7V10H10V8C10 5.3008 11.6715 4 14.0794 4C15.2328 4 16.2241 4.08587 16.5129 4.12425V6.94507L14.843 6.94583C13.5334 6.94583 13.2799 7.5681 13.2799 8.48124V10H17L16 13H13.2799V20H10.0229Z","fill":"white"}));
}

FacebookWhite.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = FacebookWhite;

FacebookWhite.default = FacebookWhite;
